import React from 'react';
import Slider, { SliderProps } from 'rc-slider';
import 'rc-slider/assets/index.css';

import { container, labelText, rangeBox } from './step-range.module.scss';
import { IOption } from '../../models/option.model';

interface IStepRangeProps {
    className?: string;
    label?: string;
    options: IOption[];
    activeOption: IOption;
    onChange?(option: IOption): void;
    children?: React.ReactNode;
}

const StepRange: React.FC<IStepRangeProps> = ({
    className = '',
    options,
    label,
    activeOption,
    onChange,
    children,
}) => {
    const marks = getMarks(options);

    const handleChange: SliderProps['onChange'] = (index) => {
        if (typeof onChange === 'function' && !Array.isArray(index)) {
            onChange(options[index]);
        }
    };

    return (
        <div className={`${container} ${className}`}>
            {label && <p className={labelText}>{label}</p>}
            <div className={rangeBox}>
                {children}
                <Slider
                    dots={true}
                    step={1}
                    min={0}
                    max={options.length - 1}
                    value={getValue(activeOption, options)}
                    marks={marks}
                    onChange={handleChange}
                />
            </div>
        </div>
    );
};

function getValue(activeOption: IOption | undefined, options: IOption[]) {
    if (!activeOption) return;
    return options.findIndex((option) => option.value === activeOption.value);
}

function getMarks(options: IOption[]): SliderProps['marks'] {
    const marks: SliderProps['marks'] = {};
    options.forEach((option, index) => {
        marks[index] = 'Wybierz';
    });
    return marks;
}

export default StepRange;
